




















import { BlogFilter } from 'client-website-ts-library/filters';
import { Blog } from 'client-website-ts-library/types';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { API } from 'client-website-ts-library/services';

import Masonry from './Layout/Masonry.vue';

@Component({
  components: {
    Masonry,
  },
})
export default class Blogs extends Vue {
  @Prop({ required: true })
  private filter!: BlogFilter;

  @Prop({ default: false })
  private archive!: boolean

  private loading = false;

  private posts: Blog[] = [];

  private load(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (this.loading) resolve(false);

      this.loading = true;

      API.Blogs.Search(this.filter).then((data) => {
        if (!this.archive) {
          this.posts = data;
        } else {
          // this.posts = data.filter((b) => b.CreateDate.Year.LongName === new Date().getFullYear().toString() && b.CreateDate.Month >= (new Date().getMonth() - 12));

          // Get the current year
          const currentYear = new Date().getFullYear();

          // Filter posts that were created in the current year
          this.posts = data.filter((b) => {
            const postYear = new Date(b.CreateDate.Value).getFullYear(); // Adjust based on the structure of `CreateDate`
            return postYear === currentYear;
          });
        }

        this.loading = false;
      }).catch(reject);
    });
  }

  loadMore() {
    API.Blogs.Search(this.filter).then((data) => {
      this.posts = data;
      this.archive = false;
      this.loading = false;
    });
  }

  mounted() {
    this.load();
  }

  @Watch('filter')
  handleFilterChanged() {
    this.load();
  }
}
